import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeDeductionListService = (
  params: Types.EmployeeDeductionListRequest
) =>
  RestAPIClient.call<Types.EmployeeDeductionListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const employeeDeductionCreateService = (
  params: Types.EmployeeDeductionCreateRequest
) =>
  RestAPIClient.call<Types.EmployeeDeduction>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeDeductionUpdateService = (
  params: Types.EmployeeDeductionUpdateRequest
) =>
  RestAPIClient.call<Types.EmployeeDeduction>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Update,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeDeductionUpdateByIdService = (
  params: Types.EmployeeDeductionUpdateByIdRequest
) =>
  RestAPIClient.call<Types.EmployeeDeduction>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${String(params.id)}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeDeductionDeleteService = (id: string) =>
  RestAPIClient.call<Types.EmployeeDeduction>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const employeeDeductionDetailService = (id: string) =>
  RestAPIClient.call<Types.EmployeeDeduction>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
